import { lazy, Suspense } from 'react'

import type { ChatMarkdownProps } from './ChatMarkdown'

const ChatMarkdown = lazy(() =>
  import('./ChatMarkdown').then((module) => ({ default: module.ChatMarkdown }))
)

export function LazyChatMarkdown(props: ChatMarkdownProps) {
  return (
    <Suspense fallback={<span className="text-ink-3">Loading markdown…</span>}>
      <ChatMarkdown {...props} />
    </Suspense>
  )
}
